import { Site } from '../site';

import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-light.css';

Site.initializeFoundation();

$(document).ready(function() {

  // Close sidemenu on endpoint scroll
  $('[data-magellan]').on('update.zf.magellan',function(e){
    if($(e.target).hasClass('menu--left') && $('#sidebar-left').hasClass('is-open')){
      $('#sidebar-left').foundation('close');
    }
  });


  hljs.configure({
    languages: [
      'bash',
      'html',
      'http',
      'css',
      'js'
    ]
  });

  $.each($('pre code'),function(i,v){
    // hljs.highlightBlock(v);
  });
});
